module.exports = __webpack_public_path__ + "static/media/imagen web alta 3.c94e8815.jpg";